import React, { useEffect, useState, useRef } from "react";
import {
  FaFileExcel,
  FaFileCode,
  FaNetworkWired,
  FaServer,
  FaCogs,
  FaSalesforce,
} from "react-icons/fa";
import MicrosoftFabric from "../../../../assets/microsoftFabric.png";
import CrateDb from "../../../../assets/crateDb.png";
import C4C from "../../../../assets/c4c.png";
import IBMDB2Logo from "../../../../assets/IBMDB2logo1.png";
import { SiPostgresql, SiMysql } from "react-icons/si";
import Modal from "../../../common/Modal/Modal";
import Spinner from "../../../common/Spinner/Spinner";
import axiosClient from "../../../../api-client/AxiosClient";
import { toast } from "react-toastify";
import { showError, showSuccess } from "../../../common/Utils";
import { globalErrorHandler } from "../../../../utils/ErrorHandler";
import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import sql from "../../../../assets/sql1.png";
import sap from "../../../../assets/sap.png";
import sage from "../../../../assets/Sage.png";
import odoo from "../../../../assets/odoo.png";
import sugarcrm from "../../../../assets/sugarcrm.png";
import infor from "../../../../assets/Infor.png";
import bullhorn from "../../../../assets/Bullhorn.png";
import exact from "../../../../assets/exact.png";
import dynamicsax from "../../../../assets/dynamicsax.png";
import jdedwards from "../../../../assets/JDEdwards.png";
import microsoftdyanamicscrm from "../../../../assets/Microcrm.png";
import microsoftdynamicsnav from "../../../../assets/Microcrm.png";
import { fetchAESKey, encryptText, isKeyLoaded } from "../../../../utils/encryption";

// this array belongs to multiple data sources
const dbFields = [
  {
    name: "server",
    label: "Server",
    type: "text",
    required: false,
  },
  {
    name: "database",
    label: "Database",
    type: "text",
    required: true,
  },
  {
    name: "username",
    label: "User Name",
    type: "text",
    required: true,
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    required: true,
  },
  {
    name: "host",
    label: "Host",
    type: "text",
    required: true,
  },
  {
    name: "port",
    label: "Port",
    type: "number",
    required: false,
  },
  {
    name: "corporationDbName",
    label: "Connection Name",
    type: "text",
    required: true,
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    required: false,
  },
];

const fileUploadField = [{ name: "file", label: "Upload File", type: "file" }];

const fieldConfig = {
  json: [{ name: "url", label: "JSON URL", type: "text" }],
  xml: fileUploadField,
  excel_csv: fileUploadField,
  csv: fileUploadField,
  api: [
    { name: "endpoint", label: "API Endpoint", type: "text" },
    { name: "headers", label: "Headers", type: "textarea" },
  ],
  postgresql: dbFields,
  mysql: dbFields,
  sqlserver: dbFields,
  microsoft_fabric: dbFields,
  CrateDb: dbFields,
  db2: dbFields,
  exact: dbFields,
  infor: dbFields,
  sage: dbFields,
  odoo: dbFields,
  sugarcrm: dbFields,
  ms_dynamics_ax: dbFields,
  ms_dynamics_crm: dbFields,
  ms_dynamics_nav: dbFields,
  jdedwards: dbFields,
  bullhorn: dbFields,

  sap_hana: [
    {
      name: "server",
      label: "Server",
      type: "text",
      required: true,
    },
    {
      name: "port",
      label: "Port",
      type: "number",
      required: true,
    },
    {
      name: "username",
      label: "User Name",
      type: "text",
      required: true,
    },
    {
      name: "password",
      label: "Password",
      type: "password",
      required: true,
    },
    {
      name: "corporationDbName",
      label: "Connection Name",
      type: "text",
      required: true,
    },
    {
      name: "description",
      label: "Description",
      type: "textarea",
      required: false,
    },
  ],
  sap_c4c: dbFields,
  salesforce: [
    { name: "consumerKey", label: "Consumer Key", type: "text", required: true },
    { name: "consumerSecret", label: "Consumer Secret", type: "text", required: true },
    { name: "securityToken", label: "Security Token", type: "text", required: true },
    { name: "username", label: "Username", type: "text", required: true },
    { name: "password", label: "Password", type: "password", required: true },
    { name: "CorporationDbName", label: "Connection Name", type: "text", required: true },
  ],
};

const DataSource = () => {
  const location = useLocation();
  const navSelectedCorporation = location.state?.selectedCorporation || null;

  // Get corporation from localStorage
  const getSelectedCorporation = () => {
    const stored = localStorage.getItem("selectedCorporation");
    return stored ? JSON.parse(stored) : null;
  };

  const [search, setSearch] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [formData, setFormData] = useState({
    server: "",
    description: "",
    port: "",
    isActive: true,
    corporationDbName: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [corporations, setCorporations] = useState([]);
  const [selectedCorporation, setSelectedCorporation] = useState(() => {
    const stored = getSelectedCorporation();
    return stored
      ? stored.value
      : navSelectedCorporation
      ? navSelectedCorporation.value
      : null;
  });
  const [mappingDBs, setMappingDBs] = useState([]);
  const dataFetched = useRef(false);
  const navigate = useNavigate();

  const handleBack = () => navigate("/data-sources");

  const handleSourceClick = (type) => {
    setSelectedType(type);

    const storedCorporation = getSelectedCorporation();
    const corporationId = storedCorporation ? storedCorporation.value : null;

    let defaultMappingDB = { name: "", description: "", isActive: true };

    const typeToDBNameMap = {
      postgresql: "PostgresSQL",
      sqlserver: "MsSql",
      microsoft_fabric: "MsSql",
      CrateDb: "CrateDb",
      db2: "Db2",
      sap_hana: "S4HANA",
      sap_c4c: "SAP_HANA",
      mysql: "MySql",
    };

    if (mappingDBs.length > 0 && typeToDBNameMap[type]) {
      const matchingDB = mappingDBs.find(
        (db) => db.name === typeToDBNameMap[type] && db.isActive === true
      );

      if (matchingDB) {
        defaultMappingDB = matchingDB;
      }
    }

    setFormData({
      server: "",
      database: "",
      username: "",
      password: "",
      host: "",
      port: "",
      corporationDbName: "",
      description: defaultMappingDB.description,
      isActive: defaultMappingDB.isActive,
      mappingDbId: defaultMappingDB.mappingdbId,
      Corporation: corporationId || "",
    });

    setShowModal(true);
  };

  const isFormValid = () => {
    const fields = fieldConfig[selectedType] || [];
    return fields.every((field) => {
      const value = formData[field.name];
      if (!field.required) return true;

      if (field.type === "file") {
        return value instanceof File;
      }
      return value !== undefined && value !== "" && value !== null;
    });
  };

  const handleInputChange = (e) => {
    const { name, value, files, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

 const handleSubmit = async () => {
  if (!selectedType) return;

  const storedCorporation = getSelectedCorporation();
  const corporationId = storedCorporation ? storedCorporation.value : null;

  if (!corporationId) {
    toast.error("Please select an Organization from the header");
    return;
  }

  try {
    setLoading(true);
    
    // Ensure AES key is loaded before encrypting
    if (!isKeyLoaded()) {
      await fetchAESKey();
    }

    let response;

    switch (selectedType) {
      case "sqlserver":
      case "postgresql":
      case "mysql":
      case "CrateDb":
      case "db2": {
        const payload = {
          corporationId: Number(corporationId),
          database: formData.database || "",
          server: formData.server || "",
          username: formData.username || "",
          password: formData.password ? encryptText(formData.password) : "",
          host: formData.host || "",
          port: formData.port || "",
          description: formData.description || "",
          corporationDbName: formData.corporationDbName || "",
          isActive: formData.isActive,
          mappingDbId: formData.mappingDbId || undefined,
        };
        if (selectedType === "mysql") {
          payload.name = formData.name || "MySQL";
        } else if (selectedType === "CrateDb") {
          payload.name = formData.name || "CrateDb";
        } else if (selectedType === "db2") {
          payload.name = "Db2";
        }
        response = await axiosClient.post("/api/MappingDB/CorpMappingDB", payload);
        break;
      }
      case "sap_hana": {
        const payload = {
          corporationId: Number(corporationId),
          server: formData.server || "",
          username: formData.username || "",
          password: formData.password ? encryptText(formData.password) : "",
          port: formData.port || "",
          description: formData.description || "",
          corporationDbName: formData.corporationDbName || "",
          isActive: formData.isActive,
        };
        
        if (formData.mappingDbId) {
          payload.mappingDbId = formData.mappingDbId;
        }
        
        response = await axiosClient.post("/api/MappingDB/CorpMappingDB", payload);
        break;
      }
      case "salesforce": {
        const payload = {
          corporationId: Number(corporationId),
          consumerKey: formData.consumerKey ? encryptText(formData.consumerKey) : "",
          consumerSecret: formData.consumerSecret ? encryptText(formData.consumerSecret) : "",
          securityToken: formData.securityToken ? encryptText(formData.securityToken) : "",
          username: formData.username || "",
          password: formData.password ? encryptText(formData.password) : "",
          corporationDbName: formData.CorporationDbName || "",
          isActive: true,
        };
        response = await axiosClient.post("/api/MappingDB/CorpMappingDB", payload);
        break;
      }
      case "json": {
        response = await axiosClient.post("/api/upload/json", formData);
        break;
      }
      case "xml": {
        const dataToSend = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
          dataToSend.append(key, value);
        });
        response = await axiosClient.post("/api/upload/xml", dataToSend);
        break;
      }
      case "excel_csv": {
        const dataToSend = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
          dataToSend.append(key, value);
        });
        response = await axiosClient.post("/api/upload/excel", dataToSend);
        break;
      }
      default: {
        toast.warning("API not configured for this source.");
        return;
      }
    }

    if (response.status === 200) {
      toast.success("Connection created successfully!");
      setShowModal(false);
    } else {
      throw new Error("No response data received");
    }
  } catch (err) {
    showError(err);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.detail.key === "selectedCorporation") {
        const newCorporation = JSON.parse(e.detail.newValue);
        setSelectedCorporation(newCorporation.value);
      }
    };

    window.addEventListener("customStorageChange", handleStorageChange);
    return () => {
      window.removeEventListener("customStorageChange", handleStorageChange);
    };
  }, []);

  const sourceData = [
    { id: "json", name: "JSON", icon: <FaFileCode size={40} color="#006400" /> },
    { id: "xml", name: "XML", icon: <FaFileCode size={40} color="#CC2927" /> },
    { id: "excel_csv", name: "Excel/CSV", icon: <FaFileExcel size={40} color="#217346" /> },
    { id: "api", name: "API", icon: <FaNetworkWired size={40} color="#007bff" /> },
    { id: "postgresql", name: "PostgreSQL", icon: <SiPostgresql size={40} color="#336791" />, mappingDbName: "PostgresSQL" },
    { id: "mysql", name: "MySQL", icon: <SiMysql size={40} color="#00758F" />, mappingDbName: "MySQL" },
    { id: "sqlserver", name: "SQL Server", icon: <img src={sql} alt="SQL" style={{ height: "40px" }} />, mappingDbName: "MsSql" },
    { id: "CrateDb", name: "Cratedb", icon: <img src={CrateDb} alt="CrateDb" style={{ height: "40px" }} />, mappingDbName: "CrateDb" },
    { id: "db2", name: "DB2", icon: <img src={IBMDB2Logo} alt="DB2" style={{ height: "40px" }} />, mappingDbName: "Db2" },
    { id: "sap_hana", name: "SAP HANA", icon: <img src={sap} alt="SAP" style={{ height: "40px" }} />, mappingDbName: "SAP_HANA" },
    { id: "salesforce", name: "Salesforce", icon: <FaSalesforce size={40} color="#007bff" /> },
    { id: "microsoft_fabric", name: "MS Fabric", icon: <img src={MicrosoftFabric} alt="Microsoft Fabric" style={{ height: "40px" }} />, mappingDbName: "PostgresSQL" },
    { id: "sap_c4c", name: "SAP C4C", icon: <img src={C4C} alt="C4C" style={{ height: "40px" }} />, mappingDbName: "SAP_HANA" },
    { id: "exact", name: "Exact ERP", icon: <img src={exact} alt="Exact" style={{ height: "40px" }} />, mappingDbName: "Exact" },
    { id: "sage", name: "Sage", icon: <img src={sage} alt="Sage" style={{ height: "40px" }} />, mappingDbName: "Sage" },
    { id: "odoo", name: "Odoo ERP", icon: <img src={odoo} alt="Odoo" style={{ height: "40px" }} />, mappingDbName: "Odoo" },
    { id: "sugarcrm", name: "SugarCRM", icon: <img src={sugarcrm} alt="SugarCRM" style={{ height: "40px" }} />, mappingDbName: "SugarCRM" },
    { id: "ms_dynamics_ax", name: "MS Dynamics AX", icon: <img src={dynamicsax} alt="Dynamics AX" style={{ height: "40px" }} />, mappingDbName: "DynamicsAX" },
    { id: "ms_dynamics_crm", name: "MS Dynamics CRM", icon: <img src={microsoftdyanamicscrm} alt="Dynamics CRM" style={{ height: "40px" }} />, mappingDbName: "DynamicsCRM" },
    { id: "ms_dynamics_nav", name: "MS Dynamics NAV", icon: <img src={microsoftdynamicsnav} alt="Dynamics NAV" style={{ height: "40px" }} />, mappingDbName: "DynamicsNAV" },
    { id: "jdedwards", name: "JD Edwards", icon: <img src={jdedwards} alt="JD Edwards" style={{ height: "40px" }} />, mappingDbName: "JDEdwards" },
    { id: "infor", name: "Infor", icon: <img src={infor} alt="Infor" style={{ height: "40px" }} />, mappingDbName: "Infor" },
    { id: "bullhorn", name: "Bullhorn", icon: <img src={bullhorn} alt="Bullhorn" style={{ height: "40px" }} />, mappingDbName: "Bullhorn" },
  ];

  const filteredSources = sourceData.filter((source) =>
    source.name.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const fetchData = async () => {
      if (dataFetched.current) return;
      setLoading(true);
      dataFetched.current = true;

      try {
              await fetchAESKey();

        const corpResponse = await axiosClient.get("/api/Corporation/GetUserCorporations");
        if (corpResponse?.data) {
          const distinctCorporations = Array.from(
            new Map(corpResponse.data.map((item) => [item.corporationId, item])).values()
          );
          setCorporations(distinctCorporations);

          const storedCorporation = getSelectedCorporation();
          if (storedCorporation) {
            setSelectedCorporation(storedCorporation.value);
          }
        }

        const mappingResponse = await axiosClient.get("/api/MappingDB");
        if (mappingResponse?.data) {
          setMappingDBs(mappingResponse.data);
        }
      } catch (error) {
        showError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="import-container">
      {loading && <Spinner />}

      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold text-gray-900">Add Data Source</h2>
        <button
          onClick={handleBack}
          className="flex items-center text-blue-600 hover:text-blue-800 p-2 rounded hover:bg-blue-50 transition-colors"
          title="Go back"
        >
          <FaArrowLeft className="mr-2" />
          Back
        </button>
      </div>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search for sources"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="data-sources">
        {filteredSources.map((source) => (
          <div
            key={source.id}
            className="source-card"
            onClick={() => handleSourceClick(source.id)}
          >
            {source.icon}
            <p>{source.name}</p>
          </div>
        ))}
      </div>

      <Modal
        show={showModal}
        title={`Configure ${selectedType?.toUpperCase()} Source`}
        setShowModal={setShowModal}
      >
        {fieldConfig[selectedType]?.map((field) => {
          if (
            (field.name === "name" || field.name === "description") &&
            selectedType &&
            sourceData.find((s) => s.id === selectedType)?.mappingDbName
          ) {
            return null;
          }

          return (
            <div key={field.name} className="modal-field">
              <label>
                {field.label}
                {field.required && <span className="text-red-500 ml-1">*</span>}
              </label>
              {field.type === "dropdown" ? (
                <select
                  name={field.name}
                  onChange={handleInputChange}
                  value={formData[field.name] || ""}
                  disabled={corporations.length === 1}
                  className={`form-select ${field.required ? "required" : ""}`}
                  required={field.required}
                >
                  <option value="" disabled>
                    Select {field.label}
                  </option>
                  {corporations.map((corp) => (
                    <option key={corp.corporationId} value={corp.corporationId}>
                      {corp.name}
                    </option>
                  ))}
                </select>
              ) : field.type === "textarea" ? (
                <textarea
                  name={field.name}
                  onChange={handleInputChange}
                  value={formData[field.name] || ""}
                  className={field.required ? "required" : ""}
                  required={field.required}
                  placeholder={
                    field.required
                      ? `Enter ${field.label}`
                      : `Enter ${field.label} (Optional)`
                  }
                />
              ) : (
                <input
                  name={field.name}
                  type={field.type}
                  value={formData[field.name] || ""}
                  onChange={handleInputChange}
                  className={field.required ? "required" : ""}
                  required={field.required}
                  placeholder={
                    field.required
                      ? `Enter ${field.label}`
                      : `Enter ${field.label} (Optional)`
                  }
                />
              )}
            </div>
          );
        })}

        <div className="modal-actions">
          <button className="cancel-btn" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button
            className={`submit-btn ${!isFormValid() ? "disabled" : ""}`}
            onClick={handleSubmit}
            disabled={!isFormValid()}
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default DataSource;
